export enum ContributionPlanScheduleEnum {
  Monthly = 'monthly',
  Every3Months = 'every_3_months',
  Every6Months = 'every_6_months',
  Yearly = 'yearly',
}
